/*
 * 작성자 : 김광민
 * 날짜 : 2024.07.04
 * 기능 : 상황판에서 가로 사이즈 5 기상종합 컴포넌트 중 현재날씨
 */

/*
 * 수정자 : 박승호
 * 날짜 : 2024.10.18
 * 수정 이유 : 눈 애니메이션 수정 & 날씨 아이콘 작은 부분 수정
 */

import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import i18n from '../../translation/i18n';
import { useEffect, useState } from 'react';
import { PulseLoader } from 'react-spinners';
import { BlurSvgIcon, CloudySvgIcon, LittleCloudySvgIcon, RainSvgIcon, ShowerSvgIcon, SleetSvgIcon, SnowSvgIcon, SunnySvgIcon } from '../Icons';
import { getWeatherIcon as getWeatherIconUtil } from '../../utils/weatherUtils';

const Root = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 2rem;
  padding: 0 1.5rem;
  padding: 0 1rem;
  position: relative;
  overflow: hidden;
  &.large {
    display: grid;
    grid-template-columns: 1fr 2fr !important;
    padding: 0 0 0 2rem;

    @media screen and (max-width: 1024px) {
      & {
        display: flex;

        .info {
          display: none;
          width: 100%;
        }

        .large-weather-top {
          width: 100%;

          .tempNow > span {
            word-break: keep-all;

            b {
              font-size: 3rem !important;
            }
          }
        }

        .large-weather-bottom {
          .bottom-weather-item {
            svg {
              width: 40px;
            }
          }
        }

        .large-info-wrapper {
          width: 100%;

          .large-weather-bottom {
            width: 100%;

            .bottom-weather-item {
              width: calc(50% - 0.25rem) !important;
            }

            .large-item-info {
              flex-wrap: wrap;
            }
          }
        }

        /* .weather-effect-container {
          display: none;
        } */
      }
    }

    > .info {
      > .maxAndMin > .details,
      > .details {
        &.location {
          padding-bottom: 1.5rem;

          > .label {
            display: none;
          }

          > .value {
            font-size: 2rem;
            font-weight: 700;
          }
        }
        > .material-symbols-rounded {
          font-size: 1.625rem;
        }
        > .label,
        > .value {
          font-size: 1.125rem;
        }
      }
    }
    > .large-info-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      position: relative;
      z-index: 10;

      .large-weather-top {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 1.75rem;

        @media screen and (max-width: 480px) {
          & {
            flex-direction: row-reverse;
            justify-content: space-between;
            padding: 2.5rem 1rem;
            gap: 0;

            .large-weather-animation {
              width: auto !important;

              svg {
                width: 100px;
              }
            }
          }
        }

        .large-weather-animation {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 182px;

          .no-weather-icon {
            font-size: 1.25rem;
          }

          .rotating-sun {
            svg {
              animation: rotation 10s infinite linear;
            }
          }
        }

        .tempNow {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          gap: 0.5rem;

          > .details {
            display: none;
            align-items: center;
            gap: 0.375rem;

            @media screen and (max-width: 768px) {
              display: flex;
            }

            .material-symbols-rounded {
              font-size: 1.25rem;
              font-variation-settings: 'FILL' 1, 'wght' 300;
            }
            .value {
              font-size: 1.25rem;
              font-weight: 500;
            }
          }

          > span {
            font-size: 1.125rem;
            font-weight: 500;

            b {
              font-size: 4.25rem;
              font-weight: 800;
            }

            &.large-date-format {
              font-size: 0.875rem;
              font-weight: 400;
            }
          }
        }
      }

      .large-weather-bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;

        .bottom-weather-item {
          display: flex;
          align-items: center;
          gap: 1rem;
          width: 210px;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 10px;
          padding: 1.25rem 1.125rem;

          .large-item-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 72px;
            height: 46px;

            svg {
              width: 100%;
            }
          }

          .large-item-details {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 0.5rem;

            .large-item-title {
              color: rgba(255, 255, 255, 0.8);
              font-size: 0.875rem;
            }

            .large-item-info {
              gap: 0.5rem;

              > span {
                font-size: 24px;
                font-weight: 600;
                color: #fff;

                &:last-child {
                  color: rgba(255, 255, 255, 0.6);
                }
              }
            }
          }
        }
      }
    }
    > .weatherAnimationWrapper {
      > .container > .svg-container {
        &.floating {
          top: 8.5%;
        }
        > svg {
          width: 12rem;
          height: 12rem;
        }
      }

      > .tempNow.large {
        position: absolute;
        top: 20%;
        left: 52%;
        transform: translateX(0%);
        font-size: 4.5rem;
        text-align: end;
        > .weatherBox-text {
          font-size: 2rem;
          font-weight: 500;
          margin-top: 0.5rem;
          margin-bottom: 1rem;
        }
      }
    }
    > .weather-effect-container {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
    }

    // 부모 요소 하단에 날씨 박스
    .weatherBox-wrapper {
      position: absolute;
      bottom: 0.75rem;
      left: 28%;
      width: 70%;
      display: flex;
      gap: 0.5rem;

      .weatherBox {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 50%;
        height: 7rem;
        border-radius: 8px;
        padding: 1rem;
        text-align: center;
        font-size: 0.875rem;
        background-color: var(--alpha-25);

        .weatherBox-title {
          font-size: 1.125rem;
          font-weight: 500;
          margin-bottom: 0.875rem;
        }

        .weatherBox-content {
          display: flex;
          justify-content: space-evenly;
          align-items: center;

          .weatherBox-details {
            font-size: 1rem;
            line-height: 1.5;
            > span:first-child {
              margin-right: 0.5rem;
            }
            > span:last-child {
              line-height: 1.25;
            }
          }
        }

        .weatherBox-icon {
          width: 3rem;
          height: 3rem;
          display: flex;
          justify-content: center;
          align-items: flex-end;
        }
      }
      .weatherBox.text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        > div {
          display: flex;
          justify-content: space-between;
        }
      }
    }

    // screen 1024px 이하일 때
    @media (max-width: 1024px) {
      padding: 0 1rem;
      grid-template-columns: repeat(1, 1fr) !important;

      .weatherAnimationWrapper {
        > .container > .svg-container > svg {
          width: 5rem;
          height: 5rem;
        }

        > .tempNow.large {
          font-size: 3rem;
          top: 25%;
          left: 70%;
        }
      }

      .weatherBox-wrapper {
        left: 2%;
        width: 96%;

        > .weatherBox {
          padding: 0.5rem;

          > .weatherBox-content > div > .weatherBox-details {
            font-size: 0.875rem;
          }
        }
      }
    }
  }

  * {
    color: white;
    // color: var(--board);
    line-height: normal;
  }
  .loading {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .unit {
    font-weight: 200;
    margin-left: 0.25rem;
  }
  .seperator {
    height: 1rem;
    border-left: 0.125rem solid var(--alpha-25);
    margin-left: 0.25rem;
  }
  .title {
    height: 4rem;
    width: 100%;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.75rem;
    font-weight: 700;
  }
  .header {
    flex-grow: 1;
    width: 100%;
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1rem;
    .tempNow {
      font-size: 3.5rem;
      font-weight: 600;
      /* margin: 0.5rem 0; */
    }
    .discrict {
      font-size: 3rem;
      font-weight: 400;
      &:before {
        content: '•';
        margin-right: 1rem;
        color: var(--alpha-50);
      }
    }
  }
  .info {
    z-index: 100;
    width: 100%;
    display: flex;
    flex-direction: column;
    .tempNow {
      font-size: 1.75rem;
      font-weight: 600;
      margin-top: 0.5rem;
    }
    .discrict {
      font-size: 3rem;
      font-weight: 400;
      &:before {
        content: '•';
        margin-right: 1rem;
        color: var(--alpha-50);
      }
    }
    .maxAndMin {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
    .details {
      display: flex;
      align-items: center;
      gap: 0.375rem;
      .material-symbols-rounded {
        font-size: 1.375rem;
        font-variation-settings: 'FILL' 1, 'wght' 300;
      }
      .label {
        font-size: 0.875rem;
        font-weight: 300;
      }
      .value {
        font-size: 0.875rem;
        font-weight: 500;
      }
    }
  }
  .weatherAnimationWrapper {
    .svg-container {
      position: initial;
      &.floating {
        position: absolute;
        left: auto;
        right: 0;
        top: 17.5%;
        top: 20.5%;
      }
      &.bouncing {
        position: absolute;
        left: auto;
        right: 0;
        top: 17.5%;
        top: 22.5%;
      }
      &.sunCloud {
        top: -10%;
        right: 4%;
      }
    }
    svg {
      width: 160px;
      height: 160px;
    }
    .sunny {
      position: absolute;
      top: 20%;
      right: 1rem;
      right: 3.5rem;
      z-index: 100;
    }
    .little_cloud {
      position: absolute;
      right: 3rem;
      top: 0;
      &.beside-sun {
        z-index: 999;
        right: 3rem;
        top: 4rem;
      }
    }
    .snow_cloud {
      position: absolute;
      right: 4rem;
      top: -40%;
    }
    .ico-blur {
      position: absolute;
      right: 4rem;
      top: -40%;
      opacity: 0.8;
    }
    .cloudy {
      left: 25% !important;
      top: 17%;
    }
    .snowdrop svg {
      width: 4rem;
      height: 4rem;
    }
  }
`;

interface Props {
  currentWeather: any;
  after2Days: any[];
  shortAdrs: string;
  size: 'small' | 'large';
}

const getWeatherText = (weather: string) => {
  switch (weather) {
    case 'sunny':
      return '맑음';
    case 'little_cloud':
      return '구름 적음';
    case 'cloudy':
      return '구름 많음';
    case 'blur':
      return '흐림';
    case 'rain':
      return '비';
    case 'sleet':
      return '진눈깨비';
    case 'snow':
      return '눈';
    case 'shower':
      return '소나기';
    default:
      return '';
  }
};

const getWeatherIconComponent = (weather: string, size: 'small' | 'large') => {
  if (size === 'small') {
    return getWeatherIconUtil(weather, 48);
  }
  return getWeatherIconUtil(weather, 72);
};

const WeatherTotalNow = ({ currentWeather, after2Days, shortAdrs, size }: Props) => {
  const days = Array.from({ length: 3 }).map((_, index) => {
    const targetDay = dayjs().add(index, 'day'); // +1 to start from tomorrow
    return {
      order: index,
      date: targetDay.date(),
      day: targetDay.format('ddd'),
    };
  });
  const { t } = useTranslation();

  const todayjs = dayjs(); // 현재 날짜와 시간을 가져옴
  let format = todayjs.format(`YYYY년 MM월 DD일 dddd`); // 기본 형식 설정

  // 언어가 영어일 경우 형식 변경
  if (i18n.language === 'en-US') {
    format = todayjs.locale('en').format(`YYYY MMMM D dddd`);
  } else {
    format = todayjs.locale('ko').format(`YYYY년 MM월 DD일 dddd`);
  }

  // SVG 표시 상태를 관리하는 상태
  const [showSvg, setShowSvg] = useState(false);

  const animateWeather = (isShowSvg: boolean, weather: string) => {
    if (size === 'small') {
      const iconSize = 160;

      switch (weather) {
        case 'sunny': {
          return (
            <div className='container'>
              <div className='svg-container show-svg '>
                <SunnySvgIcon size={iconSize} style={{ position: 'absolute', top: '6%', right: '8%' }} />
              </div>
            </div>
          );
        }

        case 'little_cloud': {
          return (
            <div className='container'>
              <div className={`svg-container ${isShowSvg ? 'show-svg' : ''}`}>
                <LittleCloudySvgIcon size={iconSize} style={{ position: 'absolute', top: '6%', right: '8%' }} />
              </div>
            </div>
          );
        }

        case 'blur': {
          return (
            <div className='container'>
              <div className='svg-container show-svg'>
                <BlurSvgIcon size={iconSize} style={{ position: 'absolute', top: '6%', right: '8%' }} />
              </div>
            </div>
          );
        }

        case 'cloudy': {
          return (
            <div className='container'>
              <div className='svg-container show-svg'>
                <LittleCloudySvgIcon size={iconSize} style={{ position: 'absolute', top: '6%', right: '8%' }} />
              </div>
            </div>
          );
        }

        case 'rain': {
          const newDrops: any[] = [];
          let increment = 0;
          while (increment < 95) {
            const randoHundo = Math.floor(Math.random() * 100);
            const randoFiver = Math.floor(Math.random() * 5) + 2;
            increment += randoFiver;

            const dropStyle = {
              left: `${increment}%`,
              animationDelay: `0.${randoHundo}s`,
              animationDuration: `0.8${randoHundo}s`,
            };

            newDrops.push(<div className='raindrop' style={dropStyle} key={increment} />);
          }

          return (
            <div className='container'>
              {newDrops}
              <div className={`svg-container ${isShowSvg ? 'show-svg' : ''}`} style={{ top: '18%' }}>
                {/** large일 때 오른쪽 여백 조정 */}
                <RainSvgIcon size={iconSize} style={{ position: 'absolute', top: '6%', right: '8%' }} />
              </div>
            </div>
          );
        }

        case 'shower': {
          const newDrops: any[] = [];
          let increment = 0;
          while (increment < 95) {
            const randoHundo = Math.floor(Math.random() * 100);
            const randoFiver = Math.floor(Math.random() * 5) + 2;
            increment += randoFiver;

            const dropStyle = {
              left: `${increment}%`,
              animationDelay: `0.${randoHundo}s`,
              animationDuration: `0.3${randoHundo}s`,
            };

            newDrops.push(<div className='raindrop' style={dropStyle} key={increment} />);
          }
          return (
            <div className='container'>
              {newDrops}
              <div className={`svg-container ${isShowSvg ? 'show-svg' : ''}`}>
                <ShowerSvgIcon size={iconSize} style={{ position: 'absolute', top: '6%', right: '8%' }} />
              </div>
            </div>
          );
        }

        case 'sleet': {
          const newDrops: any[] = [];
          let increment = 0;
          const types = ['raindrop', 'snowdrop'];

          while (increment < 100) {
            const randomType = types[Math.floor(Math.random() * types.length)];

            const randomDelay = (Math.random() * 5).toFixed(2);
            const randomUnit = Math.max(Math.floor(Math.random() * 5), 1);
            const randomLeftRight = Math.floor(Math.random() * 4);

            const snowSize = Math.floor(Math.random() * 5);
            const snowOpacity = (Math.random() * 1).toFixed(2);
            const randomDuration = Math.max(Math.floor(Math.random() * 8), 2);

            increment += randomUnit;

            let animationDuration;
            switch (randomType) {
              case 'raindrop':
                animationDuration = `${2 + Math.random()}s`;
                break;
              case 'snowdrop':
                animationDuration = `${5 + Math.random()}s`;
                break;
              default:
                animationDuration = `${5 + Math.random()}s`;
                break;
            }

            const rainParticle = {
              left: `${increment}%`,
              animationDelay: `${+randomDelay}s`,
              animationDuration,
              '--random-left-right': `${randomLeftRight}vw`,
            } as React.CSSProperties;

            const snowParticle = {
              width: `${snowSize}px`,
              height: `${snowSize}px`,
              borderRadius: `${snowSize}px`,
              backgroundColor: `#fff`,
              opacity: `${Math.max(+snowOpacity, 0.3)}`,
              left: `${increment}%`,
              animationDelay: `${+randomDelay}s`,
              animationDuration: `${randomDuration}s`,
              '--random-left-right': `${randomLeftRight}vw`,
            } as React.CSSProperties;

            newDrops.push(<div className={randomType} style={randomType === 'raindrop' ? rainParticle : snowParticle} key={increment} />);
          }

          return (
            <div className='container'>
              {newDrops}
              <div className={`svg-container ${isShowSvg ? 'show-svg' : ''}`}>
                <SleetSvgIcon size={iconSize} style={{ position: 'absolute', top: '6%', right: '8%' }} />
              </div>
            </div>
          );
        }

        case 'snow': {
          const newDrops: any[] = [];
          let increment = 0;
          while (increment < 100) {
            const randomDelay = (Math.random() * 5).toFixed(2);
            const randomUnit = Math.max(Math.floor(Math.random() * 5), 1);
            const randomLeftRight = Math.floor(Math.random() * 4);

            const snowSize = Math.floor(Math.random() * 5);
            const snowOpacity = (Math.random() * 1).toFixed(2);
            const randomDuration = Math.max(Math.floor(Math.random() * 8), 2);

            increment += randomUnit;

            const snowParticle = {
              width: `${snowSize}px`,
              height: `${snowSize}px`,
              borderRadius: `${snowSize}px`,
              backgroundColor: `#fff`,
              opacity: `${Math.max(+snowOpacity, 0.3)}`,
              left: `${increment}%`,
              animationDelay: `${+randomDelay}s`,
              animationDuration: `${randomDuration}s`,
              '--random-left-right': `${randomLeftRight}vw`,
            };

            newDrops.push(<div className='snowdrop' style={snowParticle as React.CSSProperties} key={increment} />);
          }

          return (
            <div className='container'>
              {newDrops}
              <div className='svg-container show-svg' style={{ position: 'absolute', top: '15%', right: 0 }}>
                <SnowSvgIcon size={iconSize} style={{ position: 'absolute', top: '6%', right: '8%' }} />
              </div>
            </div>
          );
        }

        case 'sunCloud': {
          return (
            <div className='container'>
              <div className={`svg-container ${isShowSvg ? 'show-svg' : ''}`}>
                <LittleCloudySvgIcon size={iconSize} style={{ position: 'absolute', top: '6%', right: '8%' }} />
              </div>
            </div>
          );
        }

        default: {
          return (
            <div className='container' style={{ position: 'absolute', top: '45%', right: '25%', fontSize: '1.25rem' }}>
              <p className='no-weather-icon'>-</p>
            </div>
          );
        }
      }
    } else {
      const iconSize = 200;
      switch (weather) {
        case 'sunny':
          return <SunnySvgIcon size={iconSize} />;
        case 'little_cloud':
          return <LittleCloudySvgIcon size={iconSize} />;
        case 'cloudy':
          return <LittleCloudySvgIcon size={iconSize} />;
        case 'blur':
          return <BlurSvgIcon size={iconSize} />;
        case 'rain':
          return <RainSvgIcon size={iconSize} />;
        case 'sleet':
          return <SleetSvgIcon size={iconSize} />;
        case 'snow':
          return <SnowSvgIcon size={iconSize} />;
        case 'shower':
          return <ShowerSvgIcon size={iconSize} />;
        default:
          return <p className='no-weather-icon'>-</p>;
      }
    }
  };

  // 날씨 배경 애니메이션
  const animateWeatherBg = (weather: string) => {
    if (size === 'large') {
      switch (weather) {
        case 'rain': {
          const newDrops: any[] = [];
          let increment = 0;
          while (increment < 95) {
            const randoHundo = Math.floor(Math.random() * 100);
            const randoFiver = Math.floor(Math.random() * 5) + 2;
            increment += randoFiver;

            const dropStyle = {
              left: `${increment}%`,
              animationDelay: `0.${randoHundo}s`,
              animationDuration: `0.8${randoHundo}s`,
            };

            newDrops.push(<div className='raindrop' style={dropStyle} key={increment} />);
          }

          return <div className='weather-effect-container'>{newDrops}</div>;
        }
        case 'shower': {
          const newDrops: any[] = [];
          let increment = 0;
          while (increment < 95) {
            const randoHundo = Math.floor(Math.random() * 100);
            const randoFiver = Math.floor(Math.random() * 5) + 2;
            increment += randoFiver;

            const dropStyle = {
              left: `${increment}%`,
              animationDelay: `0.${randoHundo}s`,
              animationDuration: `0.8${randoHundo}s`,
            };

            newDrops.push(<div className='raindrop' style={dropStyle} key={increment} />);
          }

          return <div className='weather-effect-container'>{newDrops}</div>;
        }
        case 'sleet': {
          const newDrops: any[] = [];
          let increment = 0;
          const types = ['raindrop', 'snowdrop'];

          while (increment < 100) {
            const randomType = types[Math.floor(Math.random() * types.length)];

            const randomDelay = (Math.random() * 5).toFixed(2);
            const randomUnit = Math.max(Math.floor(Math.random() * 5), 1);
            const randomLeftRight = Math.floor(Math.random() * 4);

            const snowSize = Math.floor(Math.random() * 5);
            const snowOpacity = (Math.random() * 1).toFixed(2);
            const randomDuration = Math.max(Math.floor(Math.random() * 8), 2);

            increment += randomUnit;

            let animationDuration;
            switch (randomType) {
              case 'raindrop':
                animationDuration = `${2 + Math.random()}s`;
                break;
              case 'snowdrop':
                animationDuration = `${5 + Math.random()}s`;
                break;
              default:
                animationDuration = `${5 + Math.random()}s`;
                break;
            }

            const rainParticle = {
              left: `${increment}%`,
              animationDelay: `${+randomDelay}s`,
              animationDuration,
              '--random-left-right': `${randomLeftRight}vw`,
            } as React.CSSProperties;

            const snowParticle = {
              width: `${snowSize}px`,
              height: `${snowSize}px`,
              borderRadius: `${snowSize}px`,
              backgroundColor: `#fff`,
              opacity: `${Math.max(+snowOpacity, 0.3)}`,
              left: `${increment}%`,
              animationDelay: `${+randomDelay}s`,
              animationDuration: `${randomDuration}s`,
              '--random-left-right': `${randomLeftRight}vw`,
            } as React.CSSProperties;

            newDrops.push(<div className={randomType} style={randomType === 'raindrop' ? rainParticle : snowParticle} key={increment} />);
          }

          return <div className='weather-effect-container'>{newDrops}</div>;
        }
        case 'snow': {
          const newDrops: any[] = [];
          let increment = 0;
          while (increment < 100) {
            const randomDelay = (Math.random() * 5).toFixed(2);
            const randomUnit = Math.max(Math.floor(Math.random() * 5), 1);
            const randomLeftRight = Math.floor(Math.random() * 4);

            const snowSize = Math.floor(Math.random() * 5);
            const snowOpacity = (Math.random() * 1).toFixed(2);
            const randomDuration = Math.max(Math.floor(Math.random() * 8), 2);

            increment += randomUnit;

            const snowParticle = {
              width: `${snowSize}px`,
              height: `${snowSize}px`,
              borderRadius: `${snowSize}px`,
              backgroundColor: `#fff`,
              opacity: `${Math.max(+snowOpacity, 0.3)}`,
              left: `${increment}%`,
              animationDelay: `${+randomDelay}s`,
              animationDuration: `${randomDuration}s`,
              '--random-left-right': `${randomLeftRight}vw`,
            };

            newDrops.push(<div className='snowdrop' style={snowParticle as React.CSSProperties} key={increment} />);
          }

          return <div className='weather-effect-container'>{newDrops}</div>;
        }
        default: {
          return null;
        }
      }
    }

    return null;
  };

  // SVG 표시 상태를 관리하는 상태
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSvg(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Root className={`weatherNow medium ${size}`}>
      {currentWeather.tmp === '' ? (
        <div className='loading'>
          <PulseLoader color='rgb(255, 255, 255)' size='8px' />
        </div>
      ) : (
        <>
          <div className='info'>
            <div className='details location'>
              <span className='material-symbols-rounded'>distance</span>
              <span className='label'>{t('위치')}</span>
              <span className='value'>{t(shortAdrs)}</span>
            </div>
            {size === 'small' && (
              <div className='tempNow'>
                {currentWeather.tmp}
                <span className='unit'>°</span>
              </div>
            )}
            <div className='maxAndMin'>
              <div className='details min'>
                <span className='material-symbols-rounded'>arrow_downward</span>
                <div className='value'>
                  {Math.floor(currentWeather.minTemp)}
                  <span className='unit'>°</span>
                </div>
              </div>
              <span className='seperator' />
              <div className='details max'>
                <span className='material-symbols-rounded'>arrow_upward</span>
                <div className='value'>
                  {Math.floor(currentWeather.maxTemp)}
                  <span className='unit'>°</span>
                </div>
              </div>
            </div>
            <div className='details'>
              <span className='material-symbols-rounded'>water_drop</span>
              <span className='label'>{t('강수확률')}</span>
              <span className='value'>
                {currentWeather.rainPct}
                <span className='unit'>%</span>
              </span>
            </div>
            <div className='details'>
              <span className='material-symbols-rounded'>masks</span>
              <span className='label'>{t('미세먼지')}</span>
              <span className='value'>
                {currentWeather.pm10}
                <span className='unit'>㎍/㎥</span>
              </span>
            </div>
            <div className='details'>
              <span className='material-symbols-rounded'>air</span>
              <span className='label'>{t('풍속')}</span>
              <span className='value'>
                {currentWeather.wsd}
                <span className='unit'>m/s</span>
              </span>
            </div>
          </div>
          {size === 'small' ? (
            <div className='weatherAnimationWrapper'>{animateWeather(showSvg, currentWeather.sky)}</div>
          ) : (
            <div className='large-info-wrapper'>
              <div className='large-weather-top'>
                <div className='large-weather-animation'>{animateWeather(showSvg, currentWeather.sky)}</div>
                <div className='tempNow'>
                  <div className='details location'>
                    <span className='material-symbols-rounded'>distance</span>
                    <span className='value'>{t(shortAdrs)}</span>
                  </div>
                  <span>
                    <b>{currentWeather.tmp}°</b> / {getWeatherText(currentWeather.sky)}
                  </span>
                  <span className='large-date-format'>{format}</span>
                </div>
              </div>
              <div className='large-weather-bottom'>
                <div className='bottom-weather-item'>
                  <div className='large-item-icon'>{getWeatherIconComponent(after2Days[1].sky, size)}</div>
                  <div className='large-item-details'>
                    <div className='large-item-title'>{t('내일')}</div>
                    <div className='large-item-info flex-basic'>
                      <span>{after2Days[1].minTemp}°</span>
                      <span>{after2Days[1].maxTemp}°</span>
                    </div>
                  </div>
                </div>
                <div className='bottom-weather-item'>
                  <div className='large-item-icon'>{getWeatherIconComponent(after2Days[2].sky, size)}</div>
                  <div className='large-item-details'>
                    <div className='large-item-title'>{t('모레')}</div>
                    <div className='large-item-info flex-basic'>
                      <span>{after2Days[2].minTemp}°</span>
                      <span>{after2Days[2].maxTemp}°</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* <div className='weatherAnimationWrapper'>{animateWeather(showSvg, 'sunny')}</div> */}
          {/* <div className='weatherAnimationWrapper'>{animateWeather(showSvg, 'little_cloud')}</div> */}
          {/* <div className='weatherAnimationWrapper'>{animateWeather(showSvg, 'blur')}</div> */}
          {/* <div className='weatherAnimationWrapper'>{animateWeather(showSvg, 'rain')}</div> */}
          {/* <div className='weatherAnimationWrapper'>{animateWeather(showSvg, 'sleet')}</div> */}
          {/* <div className='weatherAnimationWrapper'>{animateWeather(showSvg, 'snow')}</div> */}
          {/* <div className='weatherAnimationWrapper'>{animateWeather(showSvg, 'sunCloud')}</div> */}
        </>
      )}
      {animateWeatherBg(currentWeather.sky)}
    </Root>
  );
};

export default WeatherTotalNow;
